var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ListStyle from './ListStyle';
const List = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return React.createElement(ListStyle, Object.assign({}, otherProps), children);
};
export default List;
//# sourceMappingURL=List.js.map